{
  "name": "@archery-inc/ai-webapp",
  "private": true,
  "version": "1.42.3",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "preview": "vite preview",
    "build": "tsc && vite build",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build --stats-json",
    "test": "vitest --run",
    "test:coverage": "vitest --run --coverage",
    "semantic-release": "semantic-release -e semantic-release-commit-filter -t 'ai-v${version}'",
    "chromatic": "chromatic --only-changed --storybook-base-dir=./packages/ai-webapp"
  },
  "dependencies": {
    "@archery-inc/design-system": "workspace:*",
    "@sentry/react": "^7.106.0",
    "@sentry/vite-plugin": "^5.4.0",
    "@types/amplitude-js": "^8.16.5",
    "amplitude-js": "^8.21.9"
  },
  "devDependencies": {
    "@babel/core": "^7.29.7",
    "@babel/plugin-transform-runtime": "^7.29.7",
    "@babel/runtime": "^7.29.7",
    "@rolldown/plugin-babel": "^0.2.3",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@types/babel__core": "^7.20.5",
    "@vitejs/plugin-react": "^6.0.3",
    "babel-plugin-react-compiler": "^1.0.0",
    "semantic-release": "^23.0.2",
    "vite": "^8.1.5",
    "vite-plugin-pwa": "^1.3.0",
    "workbox-window": "^7.4.1"
  },
  "msw": {
    "workerDirectory": "public"
  }
}
